export const TipoEnergiaSeleccionadaEnum = {
  Luz: 'LUZ',
  Gas: 'GAS',
  LuzYGas: 'LUZ Y GAS',
} as const;

export type TipoEnergiaSeleccionadaEnum = typeof TipoEnergiaSeleccionadaEnum[keyof typeof TipoEnergiaSeleccionadaEnum];